
import Multiselect from 'vue-multiselect';

export default {
  name: 'FilterDropdown',

  components: {
    Multiselect,
  },

  props: {
    filterTitle: {
      type: String,
      required: true,
      default: '',
    },
    actualValue: {
      required: true,
      // default: () => {},
    },
    filterOptions: {
      type: Array,
      required: true,
      default: () => [],
    },

    mode: {
      type: String,
      required: false,
      default: 'default',
    },

    isMultiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    preventClosedScroll: {
      type: Boolean,
      required: false,
      default: false,
    },
    noTag: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  data() {
    return {
      tempValue: this.mode.includes('show-default-value')
        ? this.actualValue
        : { value: null, text: this.filterTitle, id: null },
      placeholderValue: { value: null, text: this.filterTitle, id: null },
      displayValue: this.isMultiple || this.mode.includes('show-default-value') ? this.actualValue : '',

      filterDataActualValue: this.actualValue,
      isSelected: false,
    };
  },

  watch: {
    actualValue(newValue, oldValue) {
      this.displayValue = newValue;
      this.tempValue = newValue;

      if (!this.isMultiple && !newValue?.text) this.displayValue = this.placeholderValue;
      if (this.isMultiple && (newValue === undefined || newValue?.length === 0)) {
        this.isSelected = false;
      }

      this.toggleIsSelectedAsTrue();
    },

    isSelected(newValue, oldValue) {
      if (newValue === oldValue) return;

      if (newValue) {
        this.addCustomSelectedClass();
      } else {
        this.removeCustomSelectedClass();
      }
    },
  },

  created() {
    this.toggleIsSelectedAsTrue();
  },

  mounted() {
    this.addPaddingBottomToLastOption();
    this.toggleIsSelectedAsTrue();
    this.addCustomPlaceholderClass();
  },

  methods: {
    addPaddingBottomToLastOption() {
      const selectElements = this.$refs.multiselect?.$el?.querySelectorAll(
        '.multiselect__content-wrapper > .multiselect__content > .multiselect__element'
      );

      if (selectElements == null) return;

      const lastSelectElement = selectElements[selectElements.length - 1];

      if (lastSelectElement == null) return;

      const lastSelectElementOption = lastSelectElement.querySelector('.multiselect__option');

      if (lastSelectElementOption == null) return;

      lastSelectElementOption.style.paddingBottom = '15px';
    },

    addCustomPlaceholderClass() {
      if (this.noTag) {
        const tagsElement = this.$refs.multiselect.$el?.querySelector('.multiselect__tags');
        const selectElement = this.$refs.multiselect.$el?.querySelector('.multiselect__select');
        tagsElement?.classList.add('custom-placeholder');
        selectElement?.classList.add('custom-placeholder');
      }
    },
    removeCustomPlaceholderClass() {
      if (this.noTag) {
        const tagsElement = this.$refs.multiselect.$el?.querySelector('.multiselect__tags');
        const selectElement = this.$refs.multiselect.$el?.querySelector('.multiselect__select');
        tagsElement?.classList.remove('custom-placeholder');
        selectElement?.classList.remove('custom-placeholder');
      }
    },

    // indicating a value is selected
    addCustomSelectedClass() {
      const tagsElement = this.$refs.multiselect.$el?.querySelector('.multiselect__tags');
      const selectElement = this.$refs.multiselect.$el?.querySelector('.multiselect__select');
      tagsElement?.classList.add('custom-selected');
      selectElement?.classList.add('custom-selected');
    },

    removeCustomSelectedClass() {
      const tagsElement = this.$refs.multiselect.$el?.querySelector('.multiselect__tags');
      const selectElement = this.$refs.multiselect.$el?.querySelector('.multiselect__select');
      tagsElement?.classList.remove('custom-selected');
      selectElement?.classList.remove('custom-selected');
    },

    overflowIssueHack() {
      // console.debug(this.$refs.multiselect.$el?.parentElement);
      // when opened
      // find the element with class: 'filter-wrapper no-filled-filters section-padding'
      // update overflow: visible
      // when closed
      // update overflow-x: auto
      // not sure if the above works...
    },

    onInput(value) {
      this.isSelected = true;

      // save to tempValue
      this.tempValue = value;

      // modify actualValue
      this.filterDataActualValue = this.tempValue;
      this.$emit('update:actualValue', this.tempValue);

      if (this.displayValue === undefined || this.displayValue?.length === 0) {
        this.isSelected = false;
      }
    },

    onOpened() {
      this.isSelected = false;
      if (this.noTag) {
        this.removeCustomPlaceholderClass();
      }

      // to prevent without selection - it would automatically add placeholder value
      if (this.isMultiple) return;

      // temporarily change to placeholder text
      this.displayValue = this.placeholderValue;
      this.$emit('update:displayValue', this.placeholderValue);

      // overflow issue hack
      // this.overflowIssueHack();
    },

    onClosed() {
      if (this.noTag) {
        this.addCustomPlaceholderClass();
      }
      // revert value
      if (!this.isMultiple) {
        this.displayValue = this.tempValue;
        // this.$emit('update:displayValue', this.tempValue);
      } else if (this.tempValue?.length > 0) {
        if ( !this.preventClosedScroll ) window.scrollTo(0, 0);
        this.isSelected = true;
        return;
      }
      if ( !this.preventClosedScroll ) window.scrollTo(0, 0);

      if (this.displayValue === undefined || this.displayValue?.length === 0) return;

      if (this.displayValue?.value == null) return;

      this.isSelected = true;
    },

    toggleIsSelectedAsTrue() {
      if (this.displayValue?.text) {
        this.isSelected = true;
      }
      if (this.isMultiple) {
        if (this.tempValue?.length > 0) {
          this.isSelected = true;
        }
      }
    },

    // open () {
    // 	this.$refs.multiselect.activate()
    // },
  },
};
